import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ConfiguracionMetasDispatcher,
  configuracionMetasDispatcher
} from "./ConfiguracionMetas.dispatcher";
import {
  ConfiguracionMetasStore,
  configuracionMetasStore
} from "./ConfiguracionMetas.store";
import ConfiguracionMetasComponent from "../../../components/comisionesMembresiaConfiguracion/configuracionMetas";

interface Props extends ConfiguracionMetasStore, ConfiguracionMetasDispatcher {}

@ReduxConnect(configuracionMetasStore, configuracionMetasDispatcher)
export default class ConfiguracionMetasContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Configuración de Metas" />
          <ConfiguracionMetasComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
